import React from 'react'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ Removed Navigation
import "swiper/css";
import "swiper/css/pagination";

function Urban() {
    const images = [
        {
          src: "images/urbancaro.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/urbancaro1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/urbancaro2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/Moresolutions" className="block py-1 pl-4 hover:underline mt-6">More Solutions -</Link>
           <span className="block py-1 pl-4 mt-6">URBAN</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/moresolutionscase.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">URBAN</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Modernity and functionality in a single Bakery and Coffee-Shop wall display concept .</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">URBAN is the wall display range from JORDAO, designed for assisted service and self-service, which perfectly combines product presentation, ergonomics, and versatility.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">Cafeteria <span className=' text-gray-500'> dry ambient</span></p>
       <p className="text-xl lg:text-2xl opacity-90">Bakery products<span className=' text-gray-500'> dry ambient</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Freshly baked products <span className=' text-red-600'>+40 °C</span></p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">R290</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">The best presentation for bread, whether in bulk or packaged</p>
    <div className='mt-6 text-xl md:text-2xl font-thin text-gray-500'>Minimalistic and modern design that fits perfectly into any shop. Designed to work in a linear layout or in a gondola system, the URBAN wall bread display range guarantees maximum presentation impact of your products.</div>


</div>
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/urbancase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center mt-16">
  {[
    {
      img: "images/urbancard.gif",
      text: "More options with hanging boxes, sliding drawers, wooden slatted backs, glass or slatted shelves, bags and gloves dispensers..",
    },
    {
      img: "images/urbancard1.jpg",
      text: "Food-compatible materials, flour trays... a hygienic solution that is easy to clean and maintain.",
    },
    {
      img: "images/urbancard2.jpg",
      text: "High-brightness LED lighting with low energy consumption for products that are always visible and well lit.",
    },
   
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
<div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
       
       
           {/* ✅ Image Wrapper */}
           <div className="w-full md:w-1/2">
                 <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        className=" overflow-hidden relative"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index} className="flex flex-col items-center md:p-6 relative">
            <img src={item.src} alt={`Slide ${index + 1}`} className="w-full  object-cover" />
     
          </SwiperSlide>
        ))}
      </Swiper>
               </div>
                       {/* ✅ Case Points */}
                       <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Warm baked goods as if fresh from the oven</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>URBAN heated model for freshly baked goods. Warm products for longer with drawers that allow self-service of bread, cakes, croissants, puff pastry, pretzels... with easy and quick product restock.</div>
</div>
             </div>

 {/* case 3 */}
 <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">Make the most of every centimetre of your shop</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Wall-mounted version with lighting available with glass shelves or wooden mats, hanging boxes, metal baskets... take advantage of the available wall space to display and promote your products.</div>
</div>
 {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/urbancase3.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>

            
     </div>
     {/* carosel */}
    
  
        </div>
      )
    }

export default Urban